export default __webpack_public_path__ + "static/media/loading.84b92f39.gif";